<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} pasaje
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body p-0">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off" class="m-b-50">
          <div id="accordion">
            <div class="card mb-0">
              <div class="card-header book__accordion__header" id="headingGeneral">
                <h5 class="mb-0 mt-0 font-14">
                  <a data-parent="#accordion" aria-controls="general" class="book__accordion__title">
                    <i class="fas fa-user m-r-5"></i>Datos generales
                  </a>
                </h5>
              </div>
              <div id="general" class="collapse show" aria-labelledby="headingGeneral" data-parent="#accordion">
                <div class="card-body p-l-10 p-r-10">
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label id="client_label">Cliente responsable <span class="required"></span>
                        <div class="book__nrodoc m-l-20" *ngIf="isClientSelected">
                          ( {{clientSelected.typeDocument}} : {{clientSelected.document}} )
                        </div>
                      </label>
                      <ng-container *ngIf="isClientSelected">
                        <div class="input-group">
                          <input type="text" class="form-control form-control-sm" disabled
                            value="{{clientSelected.fullname}}">
                          <div class="input-group-append bg-custom b-0 removeClient">
                            <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                              (click)="removeClient()">
                              <i class="fas fa-backspace w-100 f-s-12"></i>
                            </div>
                            <div class="input-group-text bg-info w-100 text-center text-white pointer p-l-10"
                              data-toggle="modal" data-target="#openExtendsClient"
                              (click)="ClientExtendsComponent.editClient(clientSelected.id)">
                              <i class="far fas fa-pen-alt w-100 f-s-12"></i>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="!isClientSelected">
                        <div class="input-group input-group-grid">
                          <component-search-client [classSize]="'search-small'"
                            (selectedClientEvent)="selectedClientSearch($event)" class="w-100">
                          </component-search-client>
                          <div class="input-group-append b-0">
                            <div class="input-group-text w-100 text-center pointer p-l-10" data-toggle="modal"
                              data-target="#openExtendsClient" (click)="ClientExtendsComponent.loadData()">
                              <i class="fas fa-user-plus w-100"></i>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="form-group col-lg-3">
                      <label>Número teléfono <span class="required"></span></label>
                      <div class="input-group">
                        <input type="text" class="form-control form-control-sm" id="tel_1" formControlName="tel_1"
                          remove-spaces-number required placeholder="Tel 1">
                        <div class="input-group-append">
                          <div class="input-group-text p-l-2 p-r-2">-</div>
                        </div>
                        <input type="text" class="form-control form-control-sm" id="tel_2" formControlName="tel_2"
                          remove-spaces-number placeholder="Tel 2">
                      </div>
                    </div>
                    <!-- <div class="form-group col-lg-3">
                      <label>Origen reserva <span class="required"></span></label>
                      <select class="form-control form-control-sm" id="originBookingSelected"
                        formControlName="bookingorigin_id" required>
                        <option *ngFor="let item of originsbooking" [value]="item.id">{{ item.description }}</option>
                      </select>
                    </div> -->
                    <div class="form-group col-lg-3">
                      <label>Codigo Res.vuelo <span class="required"></span></label>
                      <input type="text" class="form-control form-control-sm" formControlName="code_flight" required>
                    </div>
                    <div class="form-group col-lg-2">
                      <label>N° pasajeros</label>
                      <input type="text" class="form-control form-control-sm" id="nro_pax" formControlName="nro_passengers"
                        required numeric>                    
                    </div>
                    <!-- <div class="form-group col-lg-6">
                      <label>Asesor reserva
                        <ng-container *ngIf="employeeSelected == null">
                          (<span class="f-s-11">empleado</span>)
                        </ng-container>
                        <ng-container *ngIf="employeeSelected != null">
                          (<span class="f-s-11">{{employeeSelected.jobassigned}}</span>)
                        </ng-container>
                      </label>
                      <ng-container *ngIf="employeeSelected != null">
                        <div class="input-group">
                          <input type="text" class="form-control form-control-sm" disabled
                            value="{{employeeSelected.fullname}}">
                          <div class="input-group-append bg-custom b-0 removeClient">
                            <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                              (click)="removeEmployee()">
                              <i class="fas fa-backspace w-100 f-s-12"></i>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="employeeSelected == null">
                        <component-search-employee [classSize]="'search-small'"
                          (selectedEmployeeEvent)="selectedEmployeeSearch($event)" class="w-100">
                        </component-search-employee>
                      </ng-container>
                    </div> -->
                    <div class="form-group col-lg-3">
                      <label>Observaciones</label>
                      <input type="text" class="form-control form-control-sm" formControlName="observations">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card mb-0" *ngIf="!item.value.is_book_hotel">
              <div class="card-header book__accordion__header" id="headingTours">
                <div class="row">
                  <div class="col-lg-12 col-12">
                    <h5 class="mb-0 font-14 m-t-5">
                      <a class="collapsed book__accordion__title" data-parent="#accordion" aria-controls="tours">
                        <i class="fas fa-list-alt m-r-5"></i> Tramos de vuelo
                      </a>
                      <button type="button" class="btn btn-sm btn-outline-light f-s-10 m-l-15" (click)="toggleDiv()">
                        <i [ngClass]="showSectionFlight ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"></i>
                        {{ showSectionFlight ? 'Ocultar' : 'Mostrar' }} campos
                      </button>
                    </h5>
                  </div>
                </div>
              </div>
              <div id="tours" class="collapse show" aria-labelledby="headingTours" data-parent="#accordion">
                <div class="card-body p-l-15 p-r-15 p-t-10">
                  <div *ngIf="showSectionFlight" class="row m-b-15">
                    <div class="col-4">
                      <div class="row">
                        <div class="form-group col-lg-12">
                          <label>Apto.Salida <i class="fas fa-plane-departure"></i>
                            <span class="m-l-10 f-s-11" *ngIf="airportDeparture!=null">
                              ({{airportDeparture.city}}-{{airportDeparture.country}})
                            </span>
                          </label>
                          <ng-container *ngIf="airportDeparture!=null">
                            <div class="input-group">
                              <input type="text" class="form-control form-control-sm" disabled
                                value="{{airportDeparture.name}}">
                              <div class="input-group-append bg-custom b-0 removeClient">
                                <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                                  (click)="removeAirportDeparture()">
                                  <i class="fas fa-backspace w-100 f-s-12"></i>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="airportDeparture == null">
                            <component-search-airport [classSize]="'search-small'"
                              (selectedAirportEvent)="selectedAirportDeparture($event)" class="w-100">
                            </component-search-airport>
                          </ng-container>
                        </div>
                        <div class="form-group col-lg-12">
                          <label>Fecha/hora Salida</label>
                          <div class="input-group">
                            <input type="date" class="form-control form-control-sm" id="date_departure"
                              [(ngModel)]="dateDeparture" [ngModelOptions]="{standalone: true}">
                            <div class="input-group-append">
                              <div class="input-group-text p-l-2 p-r-2">-</div>
                            </div>
                            <div class="input-group-append">
                              <input type="time" class="form-control form-control-sm" id="time_departure"
                                [(ngModel)]="timeDeparture" [ngModelOptions]="{standalone: true}">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="row">
                        <div class="form-group col-lg-12">
                          <label>Apto.Llegada <i class="fas fa-plane-arrival"></i>
                            <span class="m-l-10 f-s-11" *ngIf="airportArrival !=null">
                              ({{airportArrival.city}}-{{airportArrival.country}})
                            </span>
                          </label>
                          <ng-container *ngIf="airportArrival!=null">
                            <div class="input-group">
                              <input type="text" class="form-control form-control-sm" disabled
                                value="{{airportArrival.name}}">
                              <div class="input-group-append bg-custom b-0 removeClient">
                                <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                                  (click)="removeAirportArrival()">
                                  <i class="fas fa-backspace w-100 f-s-12"></i>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="airportArrival == null">
                            <component-search-airport [classSize]="'search-small'"
                              (selectedAirportEvent)="selectedAirportArrival($event)" class="w-100">
                            </component-search-airport>
                          </ng-container>
                        </div>
                        <div class="form-group col-lg-12">
                          <label>Fecha/hora Llegada</label>
                          <div class="input-group">
                            <input type="date" class="form-control form-control-sm" id="date_arrival"
                              [(ngModel)]="dateArrival" [ngModelOptions]="{standalone: true}">
                            <div class="input-group-append">
                              <div class="input-group-text p-l-2 p-r-2">-</div>
                            </div>
                            <div class="input-group-append">
                              <input type="time" class="form-control form-control-sm" id="time_arrival"
                                [(ngModel)]="timeArrival" [ngModelOptions]="{standalone: true}">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="row">
                        <div class="form-group col-lg-12">
                          <label>Aerolínea</label>
                          <select class="form-control form-control-sm" id="airlineSelected"
                            [(ngModel)]="airlineSelected" [ngModelOptions]="{standalone: true}"
                            (change)="changeAirline()">
                            <option [ngValue]="null">Seleccionar opción</option>
                            <option *ngFor="let item of airlines" [value]="item.id">{{ item.description }}</option>
                          </select>
                        </div>
                        <div class="form-group col-lg-6">
                          <label>N° de vuelo</label>
                          <input type="text" class="form-control form-control-sm" [(ngModel)]="number_flight"
                            [ngModelOptions]="{standalone: true}">
                        </div>
                        <div class="form-group col-lg-6">
                          <label>.</label>
                          <a class="btn btn-sm btn-info m-l-10 f-s-11 bold text-white" (click)="addSectionFlight()">
                            <i class="fas fa-level-down-alt m-r-2"></i> Agregar tramo
                          </a>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="row">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0 table-sm">
                        <thead class="thead-default">
                          <tr>
                            <th class="text-left w-20">
                              Apto.Salida
                              <i class="m-l-3 fas fa-plane-departure"></i>
                            </th>
                            <th class="w-10 text-center">Fecha.Salida</th>
                            <th class="w-10 text-center">Hora.Salida</th>

                            <th class="text-left w-20">
                              Apto.Llegada
                              <i class="m-l-3 fas fa-plane-arrival"></i>
                            </th>
                            <th class="w-10 text-center">Fecha.Llegada</th>
                            <th class="w-10 text-center">Hora.LLegada</th>
                            <th class="nowrap text-center w-15">
                              aerolinea
                            </th>
                            <th class="nowrap text-center w-10">N°.vuelo</th>
                            <th class="text-center"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngIf="section_flights.length == 0">
                            <tr>
                              <td colspan="4"><span>No se encontraron registros</span></td>
                            </tr>
                          </ng-container>
                          <ng-container *ngIf="section_flights.length > 0">
                            <tr *ngFor="let item of section_flights; let index_ = index">
                              <td class="text-left w-20">
                                {{item.departure_airport.name}}
                              </td>
                              <td class="w-10 text-center">
                                {{item.date_departure}}
                              </td>
                              <td class="w-10 text-center">
                                {{item.time_departure}}
                              </td>
                              <td class="text-left w-20">
                                {{item.arrival_airport.name}}
                              </td>
                              <td class="w-10 text-center">
                                {{item.date_arrival}}
                              </td>
                              <td class="w-10 text-center">
                                {{item.time_arrival}}
                              </td>
                              <td class="nowrap text-center w-15">
                                {{item.tourismairlines.description}}
                              </td>
                              <td class="w-10 text-center">
                                {{item.number_flight}}
                              </td>
                              <td>
                                <i class="far fa-trash-alt book__trash"
                                  (click)="removeSectionFlight(item.id, index_)"></i>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-0 book__summary">
              <div class="card-header book__accordion__header" id="headingTours">
                <div class="row">
                  <div class="col-lg-3 col-12">
                    <h5 class="mb-0 font-14 m-t-5">
                      <a class="collapsed book__accordion__title" data-parent="#accordion" aria-controls="tours">
                        <i class="fas fa-money-bill-alt m-r-5"></i> TOTAL
                      </a>
                    </h5>
                  </div>
                </div>
              </div>
              <div id="tours" class="collapse show" aria-labelledby="headingTours" data-parent="#accordion">
                <div class="card-body p-l-15 p-r-15 p-t-10">
                  <div class="row">
                    <div class="col-lg-12 m-t-10">
                      <ng-container *ngIf="!isEdit">
                        <div class="row justify-content-md-center">
                          <div class="col-lg-3">
                            <div class="input-group">
                              <span class="input-group-prepend">
                                <span class="input-group-text bold text-primary">TOTAL RESERVA S/</span>
                              </span>
                              <input type="text"
                                class="form-control form-control-sm text-right bold text-primary f-s-14"
                                id="total_tours" onclick="click_input(this)" formControlName="total" numeric
                                decimals="2">
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="isEdit">
                        <div class="row justify-content-md-end">
                          <div class="col-lg-3">
                            <div class="input-group">
                              <span class="input-group-prepend">
                                <span class="input-group-text bold text-primary">T.RESERVA
                                  {{toolsService.momeySol()}}</span>
                              </span>
                              <input type="text"
                                class="form-control form-control-sm text-right bold text-primary f-s-14"
                                id="total_tours" onclick="click_input(this)" formControlName="total" numeric
                                decimals="2">
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div class="input-group">
                              <span class="input-group-prepend">
                                <span class="input-group-text bold f-s-12">PAGADO {{toolsService.momeySol()}}</span>
                              </span>
                              <input type="text" class="form-control form-control-sm text-right bold f-s-14"
                                id="total_paid" numeric decimals="2" disabled value="{{item.value.total_paid}}">
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div class="input-group">
                              <span class="input-group-prepend">
                                <span class="input-group-text text-danger bold f-s-12">S.PENDIENTE
                                  {{toolsService.momeySol()}}</span>
                              </span>
                              <input type="text" class="form-control form-control-sm text-right text-danger bold f-s-14"
                                id="total_paid" numeric decimals="2" disabled
                                value="{{(item.value.total - item.value.total_paid).toFixed(2)}}">
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <div class="text-right m-t-15" *ngIf="isEdit && item.dirty">
                        <span class="badge badge-info">Clic en "Guardar Cambios" para registra los cambios
                          realizados</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group col-lg-12 form__footerBtn btns-fixeds p-l-0 p-r-0 ">
            <div class="text-right">
              <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
              <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                <i class="far fa-save m-r-5"></i>
                Guardar
                <ng-container *ngIf="isEdit">
                  Cambios
                </ng-container>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<app-client-extends (onSubmitEvent)="extendsClient($event)"></app-client-extends>
